import { useParams } from "react-router-dom";

import { nameOf } from "../../../Utils/nameOf";
import { Spdr } from "../Spdr";
import { SpdrFormWithTabs } from "./SpdrFormWithTabs";
import { spdrDefaultValues } from "./spdrDefaultValues";
import { useFetchSpdr } from "../Hooks/useFetchSpdr";
import { useUpdateSpdr } from "../Hooks/useUpdateSpdr";

export const EditSpdr = () => {
  const { spdrId } = useParams();
  const { data: spdr } = useFetchSpdr(spdrId);
  const { mutate: updateSpdr } = useUpdateSpdr(spdrId);

  const disabledFields: Array<string> = [
    nameOf<Spdr>("InboundMissingPackagePercent"),
    nameOf<Spdr>("NumberOfParts"),
    nameOf<Spdr>("ShipIndicator"),
    nameOf<Spdr>("SupplierGsdb"),
    nameOf<Spdr>("PlantGsdb"),
    nameOf<Spdr>("DockCode"),
    nameOf<Spdr>("CMMS3TransitTime"),
    nameOf<Spdr>("CMMS3ShipFrequency"),
  ];

  return (
    <SpdrFormWithTabs
      title="Edit SPDR"
      spdr={spdr ?? spdrDefaultValues}
      onSave={(it: Spdr) => updateSpdr(it)}
      disabledFields={disabledFields}
    />
  );
};
